// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.locate-popup {
    position: absolute;
    text-align: center;
    transform: translate(-50%,calc(-100% - 1em));
    background: white;
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    white-space: nowrap;
    border-radius: 12px;
    padding: 1em 2em 1em 1em;
}

div.locate-popup:after {
    content: '';
    display: block;
    position: absolute;
    left: calc(50% - 1em);
    bottom: -1em;
    width: 0;
    height: 0;
    border-left: 1em solid transparent;
    border-right: 1em solid transparent;
    border-top: 1em solid white;
}

a.locate-popup-close {
    position: absolute;
    top: 0.25em;
    right: 0.25em;
    text-decoration: none;
    font-weight: bold;
    font-size: 125%;
    color: black;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/map/style/LocateSupport.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,iBAAiB;IACjB,sCAAsC;IACtC,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB","sourcesContent":["div.locate-popup {\n    position: absolute;\n    text-align: center;\n    transform: translate(-50%,calc(-100% - 1em));\n    background: white;\n    box-shadow: 0 3px 14px rgba(0,0,0,0.4);\n    white-space: nowrap;\n    border-radius: 12px;\n    padding: 1em 2em 1em 1em;\n}\n\ndiv.locate-popup:after {\n    content: '';\n    display: block;\n    position: absolute;\n    left: calc(50% - 1em);\n    bottom: -1em;\n    width: 0;\n    height: 0;\n    border-left: 1em solid transparent;\n    border-right: 1em solid transparent;\n    border-top: 1em solid white;\n}\n\na.locate-popup-close {\n    position: absolute;\n    top: 0.25em;\n    right: 0.25em;\n    text-decoration: none;\n    font-weight: bold;\n    font-size: 125%;\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
